import { ReactComponent as PartyIcon8336 } from '../../assets/icons/rooms/Anchor.svg';
import { ReactComponent as PartyIcon3015 } from '../../assets/icons/rooms/BLM.svg';
import { ReactComponent as PartyIcon3712 } from '../../assets/icons/rooms/Bikini.svg';
import { ReactComponent as PartyIcon9179 } from '../../assets/icons/rooms/Planet.svg';
import { ReactComponent as PartyIcon8110 } from '../../assets/icons/rooms/Toy_buttplug.svg';
import { ReactComponent as PartyIcon2765 } from '../../assets/icons/rooms/Toy_buttplug2.svg';
import { ReactComponent as PartyIcon2666 } from '../../assets/icons/rooms/Weird_fish.svg';
import { ReactComponent as PartyIcon6337 } from '../../assets/icons/rooms/_default_logo_room.svg';
import { ReactComponent as PartyIcon4838 } from '../../assets/icons/rooms/alien.svg';
import { ReactComponent as PartyIcon8128 } from '../../assets/icons/rooms/allpride.svg';
import { ReactComponent as PartyIcon2653 } from '../../assets/icons/rooms/art.svg';
import { ReactComponent as PartyIcon2983 } from '../../assets/icons/rooms/avocado.svg';
import { ReactComponent as PartyIcon5477 } from '../../assets/icons/rooms/balance.svg';
import { ReactComponent as PartyIcon5429 } from '../../assets/icons/rooms/balloon.svg';
import { ReactComponent as PartyIcon1687 } from '../../assets/icons/rooms/barefoot.svg';
import { ReactComponent as PartyIcon9575 } from '../../assets/icons/rooms/beard.svg';
import { ReactComponent as PartyIcon4429 } from '../../assets/icons/rooms/blade.svg';
import { ReactComponent as PartyIcon578 } from '../../assets/icons/rooms/bomb.svg';
import { ReactComponent as PartyIcon5836 } from '../../assets/icons/rooms/bong.svg';
import { ReactComponent as PartyIcon7091 } from '../../assets/icons/rooms/boombox.svg';
import { ReactComponent as PartyIcon2875 } from '../../assets/icons/rooms/booty_1.svg';
import { ReactComponent as PartyIcon8372 } from '../../assets/icons/rooms/booty_2.svg';
import { ReactComponent as PartyIcon793 } from '../../assets/icons/rooms/bottle.svg';
import { ReactComponent as PartyIcon4939 } from '../../assets/icons/rooms/bottle2.svg';
import { ReactComponent as PartyIcon5290 } from '../../assets/icons/rooms/bow.svg';
import { ReactComponent as PartyIcon2204 } from '../../assets/icons/rooms/bunny.svg';
import { ReactComponent as PartyIcon3324 } from '../../assets/icons/rooms/cake.svg';
import { ReactComponent as PartyIcon2792 } from '../../assets/icons/rooms/candy1.svg';
import { ReactComponent as PartyIcon7068 } from '../../assets/icons/rooms/cannabis.svg';
import { ReactComponent as PartyIcon7698 } from '../../assets/icons/rooms/cap.svg';
import { ReactComponent as PartyIcon3716 } from '../../assets/icons/rooms/champagne1.svg';
import { ReactComponent as PartyIcon3789 } from '../../assets/icons/rooms/champagne2.svg';
import { ReactComponent as PartyIcon7881 } from '../../assets/icons/rooms/cherries.svg';
import { ReactComponent as PartyIcon161 } from '../../assets/icons/rooms/club.svg';
import { ReactComponent as PartyIcon4182 } from '../../assets/icons/rooms/covid.svg';
import { ReactComponent as PartyIcon8507 } from '../../assets/icons/rooms/covid_mask.svg';
import { ReactComponent as PartyIcon4322 } from '../../assets/icons/rooms/covidvaccine.svg';
import { ReactComponent as PartyIcon405 } from '../../assets/icons/rooms/crown.svg';
import { ReactComponent as PartyIcon822 } from '../../assets/icons/rooms/crystals.svg';
import { ReactComponent as PartyIcon6976 } from '../../assets/icons/rooms/cuffs.svg';
import { ReactComponent as PartyIcon2814 } from '../../assets/icons/rooms/cupcake.svg';
import { ReactComponent as PartyIcon4421 } from '../../assets/icons/rooms/cute.svg';
import { ReactComponent as PartyIcon8290 } from '../../assets/icons/rooms/desert.svg';
import { ReactComponent as PartyIcon5600 } from '../../assets/icons/rooms/diamond.svg';
import { ReactComponent as PartyIcon4313 } from '../../assets/icons/rooms/dino.svg';
import { ReactComponent as PartyIcon4774 } from '../../assets/icons/rooms/dj1.svg';
import { ReactComponent as PartyIcon4288 } from '../../assets/icons/rooms/doc.svg';
import { ReactComponent as PartyIcon7132 } from '../../assets/icons/rooms/dolphins.svg';
import { ReactComponent as PartyIcon333 } from '../../assets/icons/rooms/donate.svg';
import { ReactComponent as PartyIcon9828 } from '../../assets/icons/rooms/dreamcatcher.svg';
import { ReactComponent as PartyIcon4586 } from '../../assets/icons/rooms/dress1.svg';
import { ReactComponent as PartyIcon3183 } from '../../assets/icons/rooms/dress2.svg';
import { ReactComponent as PartyIcon1680 } from '../../assets/icons/rooms/ducky.svg';
import { ReactComponent as PartyIcon3108 } from '../../assets/icons/rooms/ears.svg';
import { ReactComponent as PartyIcon5303 } from '../../assets/icons/rooms/eggplant.svg';
import { ReactComponent as PartyIcon1791 } from '../../assets/icons/rooms/fantasy.svg';
import { ReactComponent as PartyIcon3142 } from '../../assets/icons/rooms/feather.svg';
import { ReactComponent as PartyIcon6143 } from '../../assets/icons/rooms/flag.svg';
import { ReactComponent as PartyIcon6139 } from '../../assets/icons/rooms/flirt_3.svg';
import { ReactComponent as PartyIcon5478 } from '../../assets/icons/rooms/flirt_4.svg';
import { ReactComponent as PartyIcon3502 } from '../../assets/icons/rooms/flirt_5.svg';
import { ReactComponent as PartyIcon1272 } from '../../assets/icons/rooms/furry1.svg';
import { ReactComponent as PartyIcon463 } from '../../assets/icons/rooms/furry2.svg';
import { ReactComponent as PartyIcon2743 } from '../../assets/icons/rooms/gamer.svg';
import { ReactComponent as PartyIcon6732 } from '../../assets/icons/rooms/gamer2.svg';
import { ReactComponent as PartyIcon931 } from '../../assets/icons/rooms/genderqueer.svg';
import { ReactComponent as PartyIcon913 } from '../../assets/icons/rooms/ghost.svg';
import { ReactComponent as PartyIcon2947 } from '../../assets/icons/rooms/glowstick.svg';
import { ReactComponent as PartyIcon9218 } from '../../assets/icons/rooms/hat1.svg';
import { ReactComponent as PartyIcon1075 } from '../../assets/icons/rooms/hat2.svg';
import { ReactComponent as PartyIcon3269 } from '../../assets/icons/rooms/hat3.svg';
import { ReactComponent as PartyIcon8096 } from '../../assets/icons/rooms/hat4.svg';
import { ReactComponent as PartyIcon3874 } from '../../assets/icons/rooms/hawaii.svg';
import { ReactComponent as PartyIcon940 } from '../../assets/icons/rooms/headphones.svg';
import { ReactComponent as PartyIcon6032 } from '../../assets/icons/rooms/heart.svg';
import { ReactComponent as PartyIcon4612 } from '../../assets/icons/rooms/heart_broken.svg';
import { ReactComponent as PartyIcon3570 } from '../../assets/icons/rooms/heart_mending.svg';
import { ReactComponent as PartyIcon901 } from '../../assets/icons/rooms/heart_shattered.svg';
import { ReactComponent as PartyIcon1227 } from '../../assets/icons/rooms/heel1.svg';
import { ReactComponent as PartyIcon3495 } from '../../assets/icons/rooms/heel2.svg';
import { ReactComponent as PartyIcon511 } from '../../assets/icons/rooms/hightop.svg';
import { ReactComponent as PartyIcon6623 } from '../../assets/icons/rooms/hipster.svg';
import { ReactComponent as PartyIcon6353 } from '../../assets/icons/rooms/hoodie.svg';
import { ReactComponent as PartyIcon1885 } from '../../assets/icons/rooms/hookah.svg';
import { ReactComponent as PartyIcon5718 } from '../../assets/icons/rooms/jelly.svg';
import { ReactComponent as PartyIcon3440 } from '../../assets/icons/rooms/lips.svg';
import { ReactComponent as PartyIcon1338 } from '../../assets/icons/rooms/lips2.svg';
import { ReactComponent as PartyIcon4687 } from '../../assets/icons/rooms/logo_BM.svg';
import { ReactComponent as PartyIcon3104 } from '../../assets/icons/rooms/logo_puchteca.svg';
import { ReactComponent as PartyIcon8392 } from '../../assets/icons/rooms/logo_rapture.svg';
import { ReactComponent as PartyIcon660 } from '../../assets/icons/rooms/lolly.svg';
import { ReactComponent as PartyIcon9291 } from '../../assets/icons/rooms/lotus.svg';
import { ReactComponent as PartyIcon4074 } from '../../assets/icons/rooms/lsd.svg';
import { ReactComponent as PartyIcon311 } from '../../assets/icons/rooms/mahalo_sign.svg';
import { ReactComponent as PartyIcon6533 } from '../../assets/icons/rooms/masquerade.svg';
import { ReactComponent as PartyIcon961 } from '../../assets/icons/rooms/monster1.svg';
import { ReactComponent as PartyIcon3857 } from '../../assets/icons/rooms/movies.svg';
import { ReactComponent as PartyIcon6065 } from '../../assets/icons/rooms/pad.svg';
import { ReactComponent as PartyIcon3984 } from '../../assets/icons/rooms/peace_1k.svg';
import { ReactComponent as PartyIcon4031 } from '../../assets/icons/rooms/peace_sign_1k.svg';
import { ReactComponent as PartyIcon3394 } from '../../assets/icons/rooms/peach.svg';
import { ReactComponent as PartyIcon2373 } from '../../assets/icons/rooms/piercing1.svg';
import { ReactComponent as PartyIcon2312 } from '../../assets/icons/rooms/pills.svg';
import { ReactComponent as PartyIcon9845 } from '../../assets/icons/rooms/poop.svg';
import { ReactComponent as PartyIcon9393 } from '../../assets/icons/rooms/rainbow1.svg';
import { ReactComponent as PartyIcon1443 } from '../../assets/icons/rooms/rainbow2.svg';
import { ReactComponent as PartyIcon8806 } from '../../assets/icons/rooms/ramen.svg';
import { ReactComponent as PartyIcon2664 } from '../../assets/icons/rooms/robot.svg';
import { ReactComponent as PartyIcon6000 } from '../../assets/icons/rooms/safe.svg';
import { ReactComponent as PartyIcon5223 } from '../../assets/icons/rooms/safesex.svg';
import { ReactComponent as PartyIcon9061 } from '../../assets/icons/rooms/shades1.svg';
import { ReactComponent as PartyIcon1049 } from '../../assets/icons/rooms/shades2.svg';
import { ReactComponent as PartyIcon9468 } from '../../assets/icons/rooms/shades3.svg';
import { ReactComponent as PartyIcon8061 } from '../../assets/icons/rooms/shibari.svg';
import { ReactComponent as PartyIcon797 } from '../../assets/icons/rooms/siddartha.svg';
import { ReactComponent as PartyIcon2228 } from '../../assets/icons/rooms/skull.svg';
import { ReactComponent as PartyIcon245 } from '../../assets/icons/rooms/speaker.svg';
import { ReactComponent as PartyIcon10000 } from '../../assets/icons/rooms/spliff.svg';
import { ReactComponent as PartyIcon5292 } from '../../assets/icons/rooms/spraycan.svg';
import { ReactComponent as PartyIcon9628 } from '../../assets/icons/rooms/sunset.svg';
import { ReactComponent as PartyIcon3013 } from '../../assets/icons/rooms/surfboard.svg';
import { ReactComponent as PartyIcon3665 } from '../../assets/icons/rooms/tampon.svg';
import { ReactComponent as PartyIcon3472 } from '../../assets/icons/rooms/totem.svg';
import { ReactComponent as PartyIcon4214 } from '../../assets/icons/rooms/toy_collar.svg';
import { ReactComponent as PartyIcon6250 } from '../../assets/icons/rooms/toy_gag.svg';
import { ReactComponent as PartyIcon8731 } from '../../assets/icons/rooms/toy_paci.svg';
import { ReactComponent as PartyIcon6995 } from '../../assets/icons/rooms/toy_paddle.svg';
import { ReactComponent as PartyIcon348 } from '../../assets/icons/rooms/toy_vibrator.svg';
import { ReactComponent as PartyIcon5924 } from '../../assets/icons/rooms/toy_vibrator2.svg';
import { ReactComponent as PartyIcon640 } from '../../assets/icons/rooms/toy_wand.svg';
import { ReactComponent as PartyIcon7781 } from '../../assets/icons/rooms/transgender.svg';
import { ReactComponent as PartyIcon9986 } from '../../assets/icons/rooms/tribal1.svg';
import { ReactComponent as PartyIcon9305 } from '../../assets/icons/rooms/tribal2.svg';
import { ReactComponent as PartyIcon4555 } from '../../assets/icons/rooms/turntable_1k.svg';
import { ReactComponent as PartyIcon803 } from '../../assets/icons/rooms/underwear0.svg';
import { ReactComponent as PartyIcon7506 } from '../../assets/icons/rooms/underwear1.svg';
import { ReactComponent as PartyIcon6287 } from '../../assets/icons/rooms/underwear2.svg';
import { ReactComponent as PartyIcon6192 } from '../../assets/icons/rooms/underwear3.svg';
import { ReactComponent as PartyIcon8502 } from '../../assets/icons/rooms/underwear4.svg';
import { ReactComponent as PartyIcon1534 } from '../../assets/icons/rooms/vip.svg';
import { ReactComponent as PartyIcon9974 } from '../../assets/icons/rooms/weird_fruit.svg';
import { ReactComponent as PartyIcon47 } from '../../assets/icons/rooms/zombie.svg';

export type IPartyIconType = React.FunctionComponent<React.SVGProps<SVGSVGElement>> & {
  title?: string | undefined;
};

// interface IconDict<TValue> {
//   [key: string]: TValue;
// }

interface IDictionary<TValue> {
  [id: string]: TValue;
}

const icons: IDictionary<IPartyIconType> = {
  PartyIcon8336: PartyIcon8336,
  PartyIcon3015: PartyIcon3015,
  PartyIcon3712: PartyIcon3712,
  PartyIcon9179: PartyIcon9179,
  PartyIcon8110: PartyIcon8110,
  PartyIcon2765: PartyIcon2765,
  PartyIcon2666: PartyIcon2666,
  PartyIcon6337: PartyIcon6337,
  PartyIcon4838: PartyIcon4838,
  PartyIcon8128: PartyIcon8128,
  PartyIcon2653: PartyIcon2653,
  PartyIcon2983: PartyIcon2983,
  PartyIcon5477: PartyIcon5477,
  PartyIcon5429: PartyIcon5429,
  PartyIcon1687: PartyIcon1687,
  PartyIcon9575: PartyIcon9575,
  PartyIcon4429: PartyIcon4429,
  PartyIcon578: PartyIcon578,
  PartyIcon5836: PartyIcon5836,
  PartyIcon7091: PartyIcon7091,
  PartyIcon2875: PartyIcon2875,
  PartyIcon8372: PartyIcon8372,
  PartyIcon793: PartyIcon793,
  PartyIcon4939: PartyIcon4939,
  PartyIcon5290: PartyIcon5290,
  PartyIcon2204: PartyIcon2204,
  PartyIcon3324: PartyIcon3324,
  PartyIcon2792: PartyIcon2792,
  PartyIcon7068: PartyIcon7068,
  PartyIcon7698: PartyIcon7698,
  PartyIcon3716: PartyIcon3716,
  PartyIcon3789: PartyIcon3789,
  PartyIcon7881: PartyIcon7881,
  PartyIcon161: PartyIcon161,
  PartyIcon4182: PartyIcon4182,
  PartyIcon8507: PartyIcon8507,
  PartyIcon4322: PartyIcon4322,
  PartyIcon405: PartyIcon405,
  PartyIcon822: PartyIcon822,
  PartyIcon6976: PartyIcon6976,
  PartyIcon2814: PartyIcon2814,
  PartyIcon4421: PartyIcon4421,
  PartyIcon8290: PartyIcon8290,
  PartyIcon5600: PartyIcon5600,
  PartyIcon4313: PartyIcon4313,
  PartyIcon4774: PartyIcon4774,
  PartyIcon4288: PartyIcon4288,
  PartyIcon7132: PartyIcon7132,
  PartyIcon333: PartyIcon333,
  PartyIcon9828: PartyIcon9828,
  PartyIcon4586: PartyIcon4586,
  PartyIcon3183: PartyIcon3183,
  PartyIcon1680: PartyIcon1680,
  PartyIcon3108: PartyIcon3108,
  PartyIcon5303: PartyIcon5303,
  PartyIcon1791: PartyIcon1791,
  PartyIcon3142: PartyIcon3142,
  PartyIcon6143: PartyIcon6143,
  PartyIcon6139: PartyIcon6139,
  PartyIcon5478: PartyIcon5478,
  PartyIcon3502: PartyIcon3502,
  PartyIcon1272: PartyIcon1272,
  PartyIcon463: PartyIcon463,
  PartyIcon2743: PartyIcon2743,
  PartyIcon6732: PartyIcon6732,
  PartyIcon931: PartyIcon931,
  PartyIcon913: PartyIcon913,
  PartyIcon2947: PartyIcon2947,
  PartyIcon9218: PartyIcon9218,
  PartyIcon1075: PartyIcon1075,
  PartyIcon3269: PartyIcon3269,
  PartyIcon8096: PartyIcon8096,
  PartyIcon3874: PartyIcon3874,
  PartyIcon940: PartyIcon940,
  PartyIcon6032: PartyIcon6032,
  PartyIcon4612: PartyIcon4612,
  PartyIcon3570: PartyIcon3570,
  PartyIcon901: PartyIcon901,
  PartyIcon1227: PartyIcon1227,
  PartyIcon3495: PartyIcon3495,
  PartyIcon511: PartyIcon511,
  PartyIcon6623: PartyIcon6623,
  PartyIcon6353: PartyIcon6353,
  PartyIcon1885: PartyIcon1885,
  PartyIcon5718: PartyIcon5718,
  PartyIcon3440: PartyIcon3440,
  PartyIcon1338: PartyIcon1338,
  PartyIcon4687: PartyIcon4687,
  PartyIcon3104: PartyIcon3104,
  PartyIcon8392: PartyIcon8392,
  PartyIcon660: PartyIcon660,
  PartyIcon9291: PartyIcon9291,
  PartyIcon4074: PartyIcon4074,
  PartyIcon311: PartyIcon311,
  PartyIcon6533: PartyIcon6533,
  PartyIcon961: PartyIcon961,
  PartyIcon3857: PartyIcon3857,
  PartyIcon6065: PartyIcon6065,
  PartyIcon3984: PartyIcon3984,
  PartyIcon4031: PartyIcon4031,
  PartyIcon3394: PartyIcon3394,
  PartyIcon2373: PartyIcon2373,
  PartyIcon2312: PartyIcon2312,
  PartyIcon9845: PartyIcon9845,
  PartyIcon9393: PartyIcon9393,
  PartyIcon1443: PartyIcon1443,
  PartyIcon8806: PartyIcon8806,
  PartyIcon2664: PartyIcon2664,
  PartyIcon6000: PartyIcon6000,
  PartyIcon5223: PartyIcon5223,
  PartyIcon9061: PartyIcon9061,
  PartyIcon1049: PartyIcon1049,
  PartyIcon9468: PartyIcon9468,
  PartyIcon8061: PartyIcon8061,
  PartyIcon797: PartyIcon797,
  PartyIcon2228: PartyIcon2228,
  PartyIcon245: PartyIcon245,
  PartyIcon10000: PartyIcon10000,
  PartyIcon5292: PartyIcon5292,
  PartyIcon9628: PartyIcon9628,
  PartyIcon3013: PartyIcon3013,
  PartyIcon3665: PartyIcon3665,
  PartyIcon3472: PartyIcon3472,
  PartyIcon4214: PartyIcon4214,
  PartyIcon6250: PartyIcon6250,
  PartyIcon8731: PartyIcon8731,
  PartyIcon6995: PartyIcon6995,
  PartyIcon348: PartyIcon348,
  PartyIcon5924: PartyIcon5924,
  PartyIcon640: PartyIcon640,
  PartyIcon7781: PartyIcon7781,
  PartyIcon9986: PartyIcon9986,
  PartyIcon9305: PartyIcon9305,
  PartyIcon4555: PartyIcon4555,
  PartyIcon803: PartyIcon803,
  PartyIcon7506: PartyIcon7506,
  PartyIcon6287: PartyIcon6287,
  PartyIcon6192: PartyIcon6192,
  PartyIcon8502: PartyIcon8502,
  PartyIcon1534: PartyIcon1534,
  PartyIcon9974: PartyIcon9974,
  PartyIcon47: PartyIcon47,
};

export default icons;

export const Hey = icons['PartyIcon6000'];

export { PartyIcon6000 };
